import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const pains = ['CV genérico que el ATS descarta automáticamente antes de que lo lea un humano', 'Sin saber cómo presentar tu experiencia como logros que impresionan', 'Postulaciones al vacío sin estrategia ni seguimiento', 'Llegás a la entrevista sin saber qué decir ni cuánto pedir', 'El mismo ciclo. Todos los fines de semana.'];
export function PainPoints() {
  return <section className="py-24 px-4 mt-[-80px] mb-[-80px]" data-id="element-158">
      <div className="max-w-4xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-161">
            ¿Cuántos fines de semana más vas a perder así?
          </h2>
          <p className="text-xl text-slate-300 mb-2" data-id="element-162">
            Mandás CVs. No te llaman. No sabés por qué.
          </p>
          <p className="text-xl font-semibold text-[#d4a843]" data-id="element-163">
            No es falta de experiencia. Es falta de un sistema.
          </p>
        </motion.div>

        <div className="bg-[#112240] rounded-3xl p-8 md:p-12 border border-red-900/30 shadow-2xl" data-id="element-164">
          <div className="space-y-6" data-id="element-165">
            {pains.map((pain, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-166">
                <div className="mt-1 bg-red-500/10 p-1 rounded-full shrink-0" data-id="element-167">
                  <X className="w-5 h-5 text-red-500" data-id="element-168" />
                </div>
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-169">{pain}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-170">
          <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-171">
            ¿Y si este fuera el{' '}
            <span className="text-[#d4a843] border-b-2 border-[#d4a843]" data-id="element-172">
              último
            </span>{' '}
            fin de semana que pasás así?
          </p>
        </motion.div>
      </div>
    </section>;
}